import Nullstack from 'nullstack';
export default function IconArrowsMinimize({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-minimize",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "5 9 9 9 9 5"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "3",
    x2: "9",
    y2: "9"
  }), "   ", Nullstack.element("polyline", {
    points: "5 15 9 15 9 19"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "21",
    x2: "9",
    y2: "15"
  }), "   ", Nullstack.element("polyline", {
    points: "19 9 15 9 15 5"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "9",
    x2: "21",
    y2: "3"
  }), "   ", Nullstack.element("polyline", {
    points: "19 15 15 15 15 19"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "15",
    x2: "21",
    y2: "21"
  }), " ");
}